<template>
<div class="a">
  <div class="header">
    <!-- header das paginas (menos evento) -->
    <header class="bg-dark" data-block-type="headers" data-id="2">
      <div class="container">
        <nav class="navbar navbar-expand-md no-gutters">
          <div class="header__logo col-2 text-left">
            <template v-if="isPlaycenter">
              <div class="header-playcenter-logos">
                <div class="logo-wrapper" @click="handleLogoClick('playcenter')">
                  <img class="header-logo" src="/assets/images/novo_corporativo/playcenter/Logo_PlaycenterFamily_vertical.png" alt="playcenter family" />
                  <div class="logo-hover-menu">
                    <div class="menu-item" @click.stop="goToHome">
                      <i class="fas fa-home"></i>
                      Voltar para o início
                    </div>
                    <div class="menu-item" @click.stop="goToPlaycenterFamily">
                      <i class="fas fa-external-link-alt"></i>
                      Visitar o site
                    </div>
                  </div>
                </div>
                <div class="logo-wrapper" @click="handleLogoClick('playland')">
                  <img class="header-logo" style="width: 70px;" src="/assets/images/novo_corporativo/playcenter/Logo_playland_vertical.png" alt="playland" />
                  <div class="logo-hover-menu">
                    <div class="menu-item" @click.stop="goToHome">
                      <i class="fas fa-home"></i>
                      Voltar para o início
                    </div>
                    <div class="menu-item" @click.stop="goToPlayland">
                      <i class="fas fa-external-link-alt"></i>
                      Visitar o site
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <router-link v-else to="/">
              <div class="img"></div>
            </router-link>
          </div>

          <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav12" aria-controls="navbarNav12"
          aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>

          <div class="collapse navbar-collapse justify-content-center col-md-8" id="navbarNav12">
            <app-search></app-search>
          </div>

          <ul class="navbar-nav col-2 justify-content-end d-none d-md-flex">
            <span v-if="!isLogged" class="btn   btn-light to-btn hidden-xs hidden-sm" @click="login">Entrar</span>
            <span v-if="!isLogged" class="" @click="login"><img src="" alt=""></span>

            <b-dropdown v-if="isLogged" class="m-md-2" id="ddown1" :text="'Minha conta'" style="color: white !important">
              <b-dropdown-item @click="goto('legacy:my_account')">Meus pedidos</b-dropdown-item>
              <b-dropdown-item @click="modifyme">Meu cadastro</b-dropdown-item>
              <b-dropdown-item @click="goto('system:logout')">Sair</b-dropdown-item>
            </b-dropdown>

          </ul>
        </nav>
      </div>
    </header>

  </div>
  <b-navbar class="header__mobile" type="dark" variant="dark">

    <div id="myNavMobile" class="overlay">

      <!-- Overlay content -->
      <div class="overlay-content">
        <b-link href="#" @click="loadSACPage('company','sobre')">
          Sobre a empresa
        </b-link>
        <b-link href="#" @click="loadSACPage('policy','venda')">
          Politica de Venda
        </b-link>
        <b-link href="#" @click="loadSACPage('policy','desconto')">
          Política de Meia Entrada
        </b-link>
        <b-link href="#" @click="loadSACPage('policy','privacidade')">
          Politica de Privacidade
        </b-link>
        <b-link href="#" @click="loadSACPage('partner','sejaParceiro')">
          Seja nosso Parceiro
        </b-link>
      </div>

    </div>
    <div class="col-4 nav__mobile text-right">
      <div id="nav-icon3" class="toggle nav__hamburger" @click="toggleNavMobile()" @keyup.esc="toggleNavMobile()">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
    <div class="col-4 text-center mx-0 mx-auto">
      <div class="footer__logo text-left">
        <template v-if="isPlaycenter">
          <div class="mobile-playcenter-logos">
            <div class="mobile-logo-wrapper" @click="showMobileMenu = !showMobileMenu">
              <img class="mobile-logo" src="/assets/images/novo_corporativo/playcenter/Logo_PlaycenterFamily_vertical.png" alt="playcenter family" />
              <img class="mobile-logo" style="width: 45px;" src="/assets/images/novo_corporativo/playcenter/Logo_playland_vertical.png" alt="playland" />
            </div>
            <!-- Mobile Menu Modal -->
            <div class="mobile-menu" v-if="showMobileMenu" @click.self="showMobileMenu = false">
              <div class="mobile-menu-content">
                <div class="mobile-menu-header">
                  <h3>Navegação</h3>
                  <button class="close-button" @click="showMobileMenu = false">&times;</button>
                </div>
                <div class="mobile-menu-item" @click="goToHome">
                  <i class="fas fa-home"></i> Voltar para o início
                </div>
                <div class="mobile-menu-item" @click="goToPlaycenterFamily">
                  <i class="fas fa-external-link-alt"></i> Visitar Playcenter Family
                </div>
                <div class="mobile-menu-item" @click="goToPlayland">
                  <i class="fas fa-external-link-alt"></i> Visitar Playland
                </div>
              </div>
            </div>
          </div>
        </template>
        <router-link v-else to="/">
          <div class="img"></div>
        </router-link>
      </div>
    </div>
    <div class="col-4" style="color: white !important">
      <div class="icon"></div>
      <span v-if="!isLogged" class="btn    btn-light to-btn hidden-xs hidden-sm" @click="login">Entrar</span>
      <span v-if="!isLogged" class="" @click="login"><img src="" alt=""></span>
      <b-dropdown v-if="isLogged" class="m-md-2 dropdown-account-mobile" id="ddown1" :text="'Minha conta'" style="color: white !important" no-caret>
        <b-dropdown-item @click="goto('legacy:my_account')">Meus pedidos</b-dropdown-item>
        <b-dropdown-item @click="modifyme">Meu cadastro</b-dropdown-item>
        <b-dropdown-item @click="goto('system:logout')">Sair</b-dropdown-item>
      </b-dropdown>
    </div>
    <div class="col-12">
      <app-search></app-search>
    </div>
    <b-collapse is-nav id="nav_collapse">

      <b-navbar-nav>
        <b-nav-item href="#">Link</b-nav-item>
        <b-nav-item href="#" disabled>Disabled</b-nav-item>
      </b-navbar-nav>

      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">

        <b-nav-form>
          <b-form-input size="sm" class="mr-sm-2" type="text" placeholder="Search" />
          <b-button size="sm" class="my-2 my-sm-0" type="submit">Search</b-button>
        </b-nav-form>

        <b-nav-item-dropdown text="Lang" right>
          <b-dropdown-item href="#">EN</b-dropdown-item>
          <b-dropdown-item href="#">ES</b-dropdown-item>
          <b-dropdown-item href="#">RU</b-dropdown-item>
          <b-dropdown-item href="#">FA</b-dropdown-item>
        </b-nav-item-dropdown>

        <b-nav-item-dropdown right>
          <!-- Using button-content slot -->
          <template slot="button-content">
            <em>User</em>
          </template>
          <b-dropdown-item href="#">Profile</b-dropdown-item>
          <b-dropdown-item href="#">Signout</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>

    </b-collapse>
  </b-navbar>

</div>
</template>

<script>
import Vue from 'vue';
import VueResource from "vue-resource";
import VeeValidate from 'vee-validate';
import config from '@/config';
import { func } from '@/functions';

import AppSearch from "@/components/App-search.vue";
import $ from "jquery";

export default {
  name: "HeaderTicketHub",
  components: {
    AppSearch,
  },
  mixins: [func],
  data: function () {
    return {
      menuOpen: false,
      form: {
        fb: '',
        login: null,
        pass: null,
      },
      siteName: config.info.siteName,
      showMobileMenu: false,
    };
  },
  computed: {
    isLogged() {
      if (!this.ls_get("client")) return false;

      let logged = JSON.parse(this.ls_get("client"));
      if (!logged) return false;

      return true;
    },
    clientName() {
      if (!this.ls_get("client")) return "";

      let logged = JSON.parse(this.ls_get("client"));
      if (!logged) return "";

      return logged.name;
    },
    token() {
      if (!this.ls_get("client")) return "";

      let logged = JSON.parse(this.ls_get("client"));
      if (!logged) return "";

      return logged.token;
    },
  },
  created() {
    // this.login()
  },
  methods: {
    handleLogoClick(type) {
      // Default behavior can be to go home
      this.goToHome();
    },
    goToHome() {
      this.$router.push('/');
    },
    goToPlaycenterFamily() {
      window.open('https://playcenterfamily.com/', '_blank');
    },
    goToPlayland() {
      window.open('https://www.playland.com.br/', '_blank');
    },
    login() {
      this.$route.matched[0].instances.default.$parent.login();
    },
    modifyme() {
      this.$route.matched[0].instances.default.$parent.modifyme();
    },
    loadSACPage: function (categoria, pagina) {
      switch (categoria) {
        case "company":
          this.$router.push("/sac/empresa/" + pagina);
          break;
        case "policy":
          this.$router.push("/sac/politica/" + pagina);
          break;
        case "partner":
          this.$router.push("/sac/parceiros/" + pagina);
          break;
      }
    },
    goto(to, item = null) {
      switch (to) {
        case "legacy:my_account":
          this.gotoLegacy(null, "myaccount");
          break;
        case "system:logout":
          this.$store.dispatch('logout');
          break;
      }
    },
    toggleNav() {
      document.getElementById("myNav").style.width = "0%";
      $(".toggle").removeClass("open");

      if (!this.menuOpen) {
        document.getElementById("myNav").style.width = "100%";
        $(".toggle").addClass("open");
      } else {
        document.getElementById("myNav").style.width = "0%";
        $(".toggle").removeClass("open");
      }
      this.menuOpen = !this.menuOpen;
    },
    toggleNavMobile() {
      document.getElementById("myNavMobile").style.width = "0%";
      $(".toggle").removeClass("open");

      if (!this.menuOpen) {
        document.getElementById("myNavMobile").style.width = "100%";
        $(".toggle").addClass("open");
      } else {
        document.getElementById("myNavMobile").style.width = "0%";
        $(".toggle").removeClass("open");
      }
      this.menuOpen = !this.menuOpen;
    }
  }
};
</script>

<style lang="scss">
.header-playcenter-logos {
  display: flex;
  gap: 7px;
  align-items: center;
  
  .logo-wrapper {
    position: relative;
    cursor: pointer;

    &:hover {
      .header-logo {
        transform: translateY(-2px);
      }
      
      .logo-hover-menu {
        opacity: 1;
        visibility: visible;
        transform: translateX(-50%) translateY(0);
      }
    }

    .header-logo {
      width: 80px;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    }

    .logo-hover-menu {
      position: absolute;
      top: calc(100% + 10px);
      left: 50%;
      transform: translateX(-50%) translateY(-8px);
      background: white;
      border-radius: 12px;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
      padding: 8px 0;
      opacity: 0;
      visibility: hidden;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      z-index: 1000;
      min-width: 180px;
      border: 1px solid rgba(217, 31, 133, 0.1);

      &:before {
        content: '';
        position: absolute;
        top: -6px;
        left: 50%;
        transform: translateX(-50%) rotate(45deg);
        width: 12px;
        height: 12px;
        background: white;
        border-left: 1px solid rgba(217, 31, 133, 0.1);
        border-top: 1px solid rgba(217, 31, 133, 0.1);
      }

      .menu-item {
        padding: 12px 20px;
        white-space: nowrap;
        transition: all 0.2s ease;
        color: #333;
        font-size: 14px;
        display: flex;
        align-items: center;
        gap: 8px;
        position: relative;
        overflow: hidden;

        i {
          font-size: 16px;
          color: #D91F85;
          opacity: 0.9;
          width: 20px;
          text-align: center;
        }

        &:after {
          content: '';
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 1px;
          background: rgba(217, 31, 133, 0.1);
          transform: scaleX(0.95);
        }

        &:last-child:after {
          display: none;
        }

        &:hover {
          background-color: rgba(217, 31, 133, 0.05);
          color: #D91F85;
          padding-left: 24px;

          i {
            opacity: 1;
          }
        }
      }
    }
  }
}

.dropdown-account-mobile {
  #ddown1__BV_toggle_ {
    padding: 0px !important;
  }
}

.mobile-playcenter-logos {
  position: relative;
  
  .mobile-logo-wrapper {
    display: flex;
    gap: 5px;
    justify-content: center;
    align-items: center;
    
    .mobile-logo {
      width: 55px;
      height: auto;
    }
  }
}

.mobile-menu {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;

  .mobile-menu-content {
    background: white;
    width: 90%;
    max-width: 320px;
    border-radius: 12px;
    overflow: hidden;
  }

  .mobile-menu-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 20px;
    background: #D91F85;
    color: white;

    h3 {
      margin: 0;
      font-size: 18px;
      color: white;
    }

    .close-button {
      background: none;
      border: none;
      color: white;
      font-size: 24px;
      padding: 0;
      cursor: pointer;
    }
  }

  .mobile-menu-item {
    padding: 15px 20px;
    border-bottom: 1px solid #eee;
    color: #333;
    display: flex;
    align-items: center;
    gap: 10px;

    i {
      color: #D91F85;
      width: 20px;
    }

    &:active {
      background: #f5f5f5;
    }
  }
}
</style>
